// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IJmNN1X7qwJ0diYsPFnQ {
  display: flex;
  flex-direction: column;
}

/* Detalhe da carteira: card com heading + tabela separados por borda */
.IWPBPGeZucKSUyZzghHp {
  background: var(--sl-bg-base);
  border: var(--sl-border-base);
  border-radius: var(--sl-radius-3);
  overflow: hidden;
}

.ZiYjmIjUV8fSLshu3Hl6 {
  padding: var(--sl-space-4) var(--sl-space-5);
  border-bottom: var(--sl-border-base);
}

.wYk5V_8UPKLw0MAzdim_ {
  margin: 0;
  font: var(--sl-text-display-3-font);
  letter-spacing: var(--sl-letter-spacing-2);
  color: var(--sl-fg-base);
}

.jtviKPChqIgEUZKWx7WJ {
  padding: var(--sl-space-4) var(--sl-space-5);
}

.QaGy3ntwB4Qrs0DXFhFw {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  flex-wrap: wrap;
  gap: var(--sl-space-2);
}

.P6vDKEhcifEQlFYEGa5G {
  color: var(--sl-fg-base);
}

.nQqdmkHVDM3KDHeNbTa9 {
  color: var(--sl-fg-base-soft);
  font: var(--sl-text-caption-1-font);
}

.PCtUi5GCoxynjxh6JNb9 {
  margin-top: var(--sl-space-4);
}

.wh8sl4dBhZkFLZEfossI {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
  min-height: 2.25rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: var(--sl-fg-base);
  font: var(--sl-text-action-font);
  cursor: pointer;
}

.wh8sl4dBhZkFLZEfossI:hover {
  color: var(--sl-fg-base-hover, var(--sl-fg-base));
}

.wh8sl4dBhZkFLZEfossI:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-base);
}

.oPNUpf6gri3EmBigTj2a {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-2);
}

.SPzWfld0h_Z1cK2kBbHt {
  display: inline-flex;
  transition: transform 0.15s ease;
}

.sMpSsanTRlhYk6yWQfsR {
  transform: rotate(180deg);
}

.zCuPhRGJkSngBbtW4xFf {
  margin-top: var(--sl-space-3);
}

.Vmx3ieDs_4DkFgktIlyz {
  display: inline-flex;
  align-items: center;
  gap: var(--sl-space-1);
  margin-top: var(--sl-space-4);
  color: var(--sl-fg-accent);
  font: var(--sl-text-action-font);
  letter-spacing: var(--sl-text-action-letter-spacing);
  text-decoration: none;
}

.Vmx3ieDs_4DkFgktIlyz:hover {
  color: var(--sl-fg-accent-hover);
}

.Vmx3ieDs_4DkFgktIlyz:focus-visible {
  outline: none;
  box-shadow: var(--sl-focus-ring-accent);
  border-radius: var(--sl-radius-1);
}

.Vmx3ieDs_4DkFgktIlyz svg {
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/modules/retailMedia/components/WalletBalanceOrigin/styles.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,uEAAuE;AACvE;EACE,6BAA6B;EAC7B,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;EAC5C,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,0CAA0C;EAC1C,wBAAwB;AAC1B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,wBAAwB;EACxB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;EAChC,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Detalhe da carteira: card com heading + tabela separados por borda */\n.withHeading {\n  background: var(--sl-bg-base);\n  border: var(--sl-border-base);\n  border-radius: var(--sl-radius-3);\n  overflow: hidden;\n}\n\n.sectionHead {\n  padding: var(--sl-space-4) var(--sl-space-5);\n  border-bottom: var(--sl-border-base);\n}\n\n.heading {\n  margin: 0;\n  font: var(--sl-text-display-3-font);\n  letter-spacing: var(--sl-letter-spacing-2);\n  color: var(--sl-fg-base);\n}\n\n.sectionBody {\n  padding: var(--sl-space-4) var(--sl-space-5);\n}\n\n.originCell {\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: var(--sl-space-2);\n}\n\n.originName {\n  color: var(--sl-fg-base);\n}\n\n.originCaption {\n  color: var(--sl-fg-base-soft);\n  font: var(--sl-text-caption-1-font);\n}\n\n.expiredWrap {\n  margin-top: var(--sl-space-4);\n}\n\n.expiredToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n  min-height: 2.25rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: var(--sl-fg-base);\n  font: var(--sl-text-action-font);\n  cursor: pointer;\n}\n\n.expiredToggle:hover {\n  color: var(--sl-fg-base-hover, var(--sl-fg-base));\n}\n\n.expiredToggle:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-base);\n}\n\n.expiredToggleLabel {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-2);\n}\n\n.expiredCaret {\n  display: inline-flex;\n  transition: transform 0.15s ease;\n}\n\n.expiredCaretOpen {\n  transform: rotate(180deg);\n}\n\n.expiredPanel {\n  margin-top: var(--sl-space-3);\n}\n\n.walletDetailLink {\n  display: inline-flex;\n  align-items: center;\n  gap: var(--sl-space-1);\n  margin-top: var(--sl-space-4);\n  color: var(--sl-fg-accent);\n  font: var(--sl-text-action-font);\n  letter-spacing: var(--sl-text-action-letter-spacing);\n  text-decoration: none;\n}\n\n.walletDetailLink:hover {\n  color: var(--sl-fg-accent-hover);\n}\n\n.walletDetailLink:focus-visible {\n  outline: none;\n  box-shadow: var(--sl-focus-ring-accent);\n  border-radius: var(--sl-radius-1);\n}\n\n.walletDetailLink :global(svg) {\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `IJmNN1X7qwJ0diYsPFnQ`,
	"withHeading": `IWPBPGeZucKSUyZzghHp`,
	"sectionHead": `ZiYjmIjUV8fSLshu3Hl6`,
	"heading": `wYk5V_8UPKLw0MAzdim_`,
	"sectionBody": `jtviKPChqIgEUZKWx7WJ`,
	"originCell": `QaGy3ntwB4Qrs0DXFhFw`,
	"originName": `P6vDKEhcifEQlFYEGa5G`,
	"originCaption": `nQqdmkHVDM3KDHeNbTa9`,
	"expiredWrap": `PCtUi5GCoxynjxh6JNb9`,
	"expiredToggle": `wh8sl4dBhZkFLZEfossI`,
	"expiredToggleLabel": `oPNUpf6gri3EmBigTj2a`,
	"expiredCaret": `SPzWfld0h_Z1cK2kBbHt`,
	"expiredCaretOpen": `sMpSsanTRlhYk6yWQfsR`,
	"expiredPanel": `zCuPhRGJkSngBbtW4xFf`,
	"walletDetailLink": `Vmx3ieDs_4DkFgktIlyz`
};
export default ___CSS_LOADER_EXPORT___;
